import React from "react";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { getReportSettingByKey } from "src/app/ReportGenerator/utils/reportFunctions";

export const getDataAggregationSections = (canDisplaySentiments) => [
  {
    value: "creatorsInsights",
    label: (
      <IDHFormattedMessage
        id="ws_creator_insights"
        defaultMessage="Creator Insights"
      />
    ),
    types: ["creator-insights"],
    headerId: "#header-2-creator-insights",
  },
  {
    value: "creatorsInTheCampaign",
    label: (
      <IDHFormattedMessage
        id="ws_creators_in_the_campaign"
        defaultMessage="Creators in the Campaign"
      />
    ),
    types: ["creator"],
    headerId: "#header-2-creator",
  },
  {
    value: "campaignAudienceData",
    label: (
      <IDHFormattedMessage
        id="ws_campaign_audience_data"
        defaultMessage="Campaign Audience Data"
      />
    ),
    types: ["audience-data"],
    headerId: "#header-2-audience-data",
  },
  {
    value: "allPublications",
    label: (
      <IDHFormattedMessage
        id="ws_all_publications"
        defaultMessage="All Publications"
      />
    ),
    types: ["publication"],
    headerId: "#header-2-publication",
  },
  {
    value: "summary",
    label: <IDHFormattedMessage id="ws_summary" defaultMessage="Summary" />,
    types: ["table-summary"],
    headerId: "#header-1-table-summary",
  },
  ...(canDisplaySentiments
    ? [
        {
          value: "commentsAnalysis",
          label: (
            <IDHFormattedMessage
              id="ws_comments_analysis"
              defaultMessage="Comments analysis"
            />
          ),
          types: ["comments-analysis", "sentiment-analysis", "comments"],
          headerId: "#header-1-comments-analysis",
        },
      ]
    : []),
];

export const canAggregate = (defaultValue) => {
  const campaignsCount = getReportSettingByKey("ids")?.length;

  if (campaignsCount <= 1) {
    return false;
  }

  return defaultValue;
};

export const getAggregatedOrFirstByKey = (campaigns, key) => {
  const campaignsCount = Object.keys(campaigns)?.length;

  if (campaignsCount === 0) return [];

  if (campaignsCount <= 1) {
    return Object.values(campaigns)[0][key];
  }

  return campaigns.aggregated[key];
};
